import { render, staticRenderFns } from "./UsuariosPorCartera.vue?vue&type=template&id=cd9afa88&"
import script from "./UsuariosPorCartera.vue?vue&type=script&lang=js&"
export * from "./UsuariosPorCartera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports